export enum SamplingJobStatus {
  JobSetup = 1,
  SamplingInProgress = 2,
  SamplingComplete = 3,
  AwaitingResults = 4,
  JobComplete = 5,
}

export interface SamplingJob {
  id: number;
  subtitle: string;
  companyTitle: string;
  clientId: number;
  clientTitle: string;
  clientRef?: string;
  orderNumber?: string;
  plannedDate?: string;
  estimatedDays: number;
  statusId: SamplingJobStatus;
  statusTitle: string;
  daysInStatus: number;
  samplerIds: number[];
  description?: string;
  active: boolean;
}

export interface SamplingJobParams {
  showInactive?: boolean;
  showUnassigned?: boolean;
  startDate?: Date;
  endDate?: Date;
}

export interface SamplingJobStatusRef {
  id: SamplingJobStatus;
  title: string;
}

export interface SamplingJobSampleType {
  sensorTypeId: number;
  sensorTypeTitle: string;
  productGroupId: number;
  productGroupTitle: string;
  fieldCount: number;
  plannedCount: number;
  takenCount: number;
}

export interface SamplingJobSampler {
  id: number;
  forename: string;
  surname: string;
  username: string;
}

export interface SamplerUser {
  id: number;
  forename: string;
  surname: string;
  username: string;
  weeklyWorkdays: number;
  weeklySampleEstimate: number;
  active: boolean;
}

export interface SamplerUserParams {
  showInactive?: boolean;
}

export interface SamplerRequest {
  samplerId: number;
  weeklyWorkdays: number;
  weeklySampleEstimate: number;
  active: boolean;
}

export interface SamplingJobRequest {
  jobId: number;
  plannedDate?: string;
  estimatedDays: number;
  statusId: SamplingJobStatus;
  active: boolean;
}

export interface SamplingJobMetric {
  plannedDate: string;
  jobStatus: string;
  sampler?: string;
  sampleType: string;
  sampled: boolean;
  sampleCount: number;
}

export interface SamplingJobMetricParams {
  startDate?: Date;
  endDate?: Date;
}

export interface SamplingJobStatusMetric {
  statusTitle: string;
  jobCount: number;
}

export interface SamplingJobStatusMetricParams {
  startDate?: Date;
  endDate?: Date;
}
